import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../store/user/action";
import { CreatorDetails } from "../component/dialog/CreatorDetails";
import { useTranslation } from "react-i18next";
import CoinSeller from "../component/dialog/CoinSeller";
import { OPEN_COIN_SELLER_DIALOGUE } from "../store/seller/seller.type.js";
import { permissionError } from "../util/Alert.js";

const T = {
  pageBg: "#33083e",
  text: "#F5F3FF",
  sub: "#B8A9C9",
  border: "rgba(255,255,255,0.12)",
  pinkGrad: "linear-gradient(180deg, #F861B1 0%, #E91384 100%)",
};

const Creators = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const admin = useSelector((state) => state.admin.seller);
  const agencyId = localStorage.getItem("agencyId");

  useEffect(() => {
    if (agencyId) {
      dispatch(getUser(agencyId, { start: 1, limit: 200 }));
    }
  }, [dispatch, agencyId]);

  const handleOpenCreator = () => {
    if (admin?.isActive === false) return permissionError();
    dispatch({ type: OPEN_COIN_SELLER_DIALOGUE });
  };

  return (
    <>
      <div
        style={{
          background: T.pageBg,
          minHeight: "100%",
          width: "100%",
          maxWidth: "100%",
          overflowX: "hidden",
          color: T.text,
        }}
      >
        <div
          style={{
            position: "sticky",
            top: 0,
            zIndex: 9,
            background: T.pageBg,
            padding: "14px 16px",
            borderBottom: `1px solid ${T.border}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 10,
          }}
        >
          <div>
            <div style={{ fontWeight: 700, fontSize: 18 }}>{t("host")}</div>
            <div style={{ fontSize: 12, color: T.sub, marginTop: 2 }}>
              {t("manage_agency_view")}
            </div>
          </div>
          <button
            type="button"
            onClick={handleOpenCreator}
            style={{
              fontSize: 13,
              fontWeight: 600,
              background: T.pinkGrad,
              color: "#fff",
              border: "none",
              padding: "11px 14px",
              borderRadius: 12,
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            + {t("add_host")}
          </button>
        </div>

        <div style={{ padding: "12px 16px 24px" }}>
          <CreatorDetails skipFetch />
        </div>
      </div>
      <CoinSeller />
    </>
  );
};

export default Creators;
